/* Kryss-kontekst synk av innlogging (localStorage «storage»-hendinga).
   Appen lastar sida på nytt når tokenet endrar seg i ei anna fane / ramme, slik at ingen får sjå ein annan brukar sine
   mellomlagra data. Offentlege sider som berre *viser* systemet i rammer (tilbodet) treng ikkje det – og skal ikkje hoppe
   når ramma loggar inn i demoen. Dei slår det av medan dei er monterte. */
let suppressed = false;

export const suppressAuthReload = (on) => {
  suppressed = !!on;
};

export const isAuthReloadSuppressed = () => suppressed;

/* Demo-kontoane som finst i prototypen (same liste som innloggingssida viser). */
export const DEMO_ACCOUNTS = [
  ["admin", "Administrator"],
  ["salg", "Salg"],
  ["pl", "Prosjektleder"],
  ["fleet", "Flåte"],
  ["felt", "Felt (mobil)"],
  ["leder", "Ledelse"],
];

export const demoCredentials = (key) => {
  if (!DEMO_ACCOUNTS.some(([k]) => k === key)) return null;
  return { email: `${key}@stord-innkvartering.no`, password: key === "admin" ? "Admin123!" : "Passord123!" };
};

/* Intern sti som er trygg å sende vidare til etter innlogging (same origin, ingen protokoll-relative lenker). */
export const safeNext = (p) => (typeof p === "string" && p.startsWith("/") && !p.startsWith("//") ? p : null);

/* Adresse som opnar prototypen innlogga som ein demo-konto og går til ønskt side. */
export const demoEntry = (path = "/", key = "leder") => `/login?demo=${encodeURIComponent(key)}&next=${encodeURIComponent(path)}`;
